import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';
import { GetFaqResponse, UpdateFaqRequest } from './dto';

export class FaqApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.getFaq = this.getFaq.bind(this);
    this.getAdminFaq = this.getAdminFaq.bind(this);
    this.updateFaq = this.updateFaq.bind(this);
    this.updateAdminFaq = this.updateAdminFaq.bind(this);
  }

  public async getFaq(): ApiResult<GetFaqResponse> {
    return await this.get<GetFaqResponse>('/faq');
  }

  public async getAdminFaq(): ApiResult<GetFaqResponse> {
    return await this.get<GetFaqResponse>('/adminFaq');
  }

  public async updateFaq(body: UpdateFaqRequest): ApiResult<void> {
    return await this.put<void>('/faq', body);
  }

  public async updateAdminFaq(body: UpdateFaqRequest): ApiResult<void> {
    return await this.put<void>('/adminFaq', body);
  }
}
